import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import NotificationAffectation from "./NotificationAffectation";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { InterventionParTicket } from "../../_App/Redux/Slices/interventions/interventionSlice";
import FicheInterventionModal from "../Interventions/FicheInterventionModal";
import { InterventionType } from "../../_App/Types/Entites/InterventionType";
import no_image from "../../../public/assets/assets/img/no-image.jpg";
import {
  ImagesTickets,
  updateTicket,
} from "../../_App/Redux/Slices/tickets/ticketSlice";
import ZoomableImage from "../imagePreview/ImagePreview";
import Swal from "sweetalert2";
import { updateResult } from "../../_App/Redux/Slices/checklists/checklistSlice";
import { currentUser } from "../../_App/Redux/Slices/auth/authSlice";

const Ticket = ({
  ShowModal,
  setShowModal,
  setSelectedTicket,
  selectedTicket,
  setShowIntervention,
  setSelectedIntervention,
  stop,
}: any) => {
  const [ShowModalAffectation, setShowModalAffectation] = useState(false);
  const interventions = useAppSelector(InterventionParTicket);
  const userOnline = useAppSelector(currentUser);
  const [commentaire, setCommentaire] = useState("");
  const images = useAppSelector(ImagesTickets);
  const dispatch = useAppDispatch();
  var currentDate = new Date();
  var hours = currentDate.getHours();
  var minutes = currentDate.getMinutes();
  var seconds = currentDate.getSeconds();
  var formattedTime = hours + ":" + minutes + ":" + seconds;
const clotureTicket = () => {
  if (!commentaire || commentaire.trim() === "") {
    Swal.fire({
      title: "Commentaire requis",
      text: "Veuillez saisir un commentaire avant de clôturer le ticket.",
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }

  Swal.fire({
    title: "Êtes-vous sûr ?",
    text: "Vous ne pourrez pas annuler cette action !",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, clôturer !",
    cancelButtonText: "Annuler",
  }).then((result) => {
    if (result.isConfirmed) {
      dispatch(
        updateTicket({
          id: selectedTicket.id,
          newData: {
            cloture: 1,
            commentaire_cloture: commentaire,
          },
        })
      );

      if (selectedTicket.result_id) {
        dispatch(
          updateResult({
            id: selectedTicket.result_id,
            newData: {
              derogation: 1,
              derogateur: userOnline?.code,
              heure_derogation: formattedTime,
            },
          })
        );
      }

      Swal.fire({
        title: "Clôturé !",
        text: "Le ticket a été clôturé avec succès.",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          setShowModal(false);
        }
      });
    }
  });
};


  return (
    <div>
      <NotificationAffectation
        ShowModal={ShowModalAffectation}
        setShowModal={setShowModalAffectation}
        notification={selectedTicket}
      />

      <Modal
        show={ShowModal}
        onHide={() => {
          setSelectedTicket(undefined);
          setShowModal(false);
        }}
        dialogClassName="modal-transparent" // Add this class for styling
        centered
      >
        <Modal.Body>
          <div className="signboard outer">
            <div className="signboard front inner anim04c">
              <div className="app">
                <main className="project" style={{ height: "100%" }}>
                  <div className="project-info"></div>
                  <div className="project-tasks">
                    <div className="project-column">
                      <div className="task" draggable="true">
                        <div className="task__tags">
                          <span
                            className="task__tag task__tag--copyright"
                            style={{ textTransform: "uppercase" }}
                            onClick={() => console.log(selectedTicket.code)}
                          >
                            <i className="fas fa-cogs"></i>
                            {"  Machine " +
                              selectedTicket?.Machine?.nom +
                              " - Type : " +
                              selectedTicket?.type}
                          </span>
                          <span
                            className="task__tag task__tag--copyright"
                            style={{ textTransform: "uppercase" }}
                          >
                            {"  ODP " + selectedTicket?.odf_code}
                          </span>
                          <button
                            className="task__options"
                            onClick={() => {
                              setSelectedTicket(undefined);
                              setShowModal(false);
                            }}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            {selectedTicket &&
                            images[selectedTicket.code] &&
                            images[selectedTicket.code][0] ? (
                              <ZoomableImage
                                size={170}
                                imageUrl={
                                  images[selectedTicket.code][0]?.path ||
                                  "/assets/assets/img/no-image.jpg"
                                }
                              />
                            ) : (
                              <img
                                src={"assets/assets/img/no-image.jpg"}
                                width={170}
                                height={170}
                                alt="zoomable"
                              />
                            )}
                          </div>

                          <div className="col-6">
                            {" "}
                            <div className="project-column-heading">
                              <h2 className="project-column-heading__title">
                                {selectedTicket?.objet}
                              </h2>
                            </div>
                            <div className="project-column-heading">
                              <h6
                                className="project-column-heading__title"
                                style={{ fontSize: "16px" }}
                              >
                                {selectedTicket?.Panne
                                  ? "Panne : " + selectedTicket?.Panne?.libelle
                                  : null}
                              </h6>
                            </div>
                            <p className="m-0">{selectedTicket?.description}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="task__stats">
                            <span>
                              <time>
                                <i className="fas fa-flag"></i>
                                {selectedTicket?.date.toString().split("T")[0]}
                              </time>
                            </span>
                            <span>
                              <i className="fas fa-user"></i>
                              {selectedTicket?.CreatorUser?.nom +
                                " " +
                                selectedTicket?.CreatorUser?.prenom}
                            </span>
                            {selectedTicket?.cloture === 0 ? (
                              <div className="row align-items-center g-2">
                                <div className="col-md-8 col-12">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ajouter un commentaire..."
                                    value={commentaire}
                                    onChange={(e) =>
                                      setCommentaire(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="col-md-4 col-12 text-end">
                                  <button
                                    className="btn btn-danger w-100"
                                    onClick={() => clotureTicket()}
                                  >
                                    <i className="fas fa-lock me-2"></i>{" "}
                                    Clôturer
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="d-flex align-items-center mt-2">
                                <i className="fas fa-check-circle text-success me-2"></i>
                                <span className="affectation fw-bold">
                                  Clôturée par{" "}
                                  <span className="text-primary">
                                    {selectedTicket?.agent_cloture}
                                  </span>
                                </span>
                              </div>
                            )}

                            {selectedTicket && selectedTicket.affected_to ? (
                              <span className="affectation">
                                <i className="fas fa-recycle"></i>{" "}
                                {"Affecté a " +
                                  selectedTicket?.UserAffectedTo?.nom +
                                  " " +
                                  selectedTicket?.UserAffectedTo?.prenom}
                              </span>
                            ) : selectedTicket &&
                              selectedTicket.affected_to &&
                              selectedTicket.cloture === 0 ? (
                              <span
                                className="task__owner"
                                onClick={() => setShowModalAffectation(true)}
                              >
                                <i className="fas fa-recycle"></i>Affecter
                              </span>
                            ) : null}
                          </div>
                        </div>

                        {!stop &&
                        interventions &&
                        selectedTicket &&
                        interventions[selectedTicket.code] &&
                        interventions[selectedTicket.code].length ? (
                          <>
                            <div className="project-column-heading mb-0">
                              <h2
                                className="project-column-heading__title"
                                onClick={() =>
                                  console.log(
                                    interventions[selectedTicket.code]
                                  )
                                }
                              >
                                Interventions :
                              </h2>
                            </div>
                            <div className="row">
                              {interventions[selectedTicket.code].map(
                                (item, index) => (
                                  <span
                                    key={index}
                                    onClick={() => {
                                      setSelectedIntervention(item);
                                      setShowIntervention(true);
                                    }}
                                    className="usr-ph-no"
                                    style={{
                                      textDecoration: "underline",
                                      color: "#4361ee",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {" "}
                                    {item.InterventionAction?.libelle ||
                                      item?.InterventionGroupe?.libelle}{" "}
                                  </span>
                                )
                              )}
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </div>

            <div className="signboard left inner anim04c"></div>
            <div className="signboard right inner anim04c"></div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Ticket;
